// @flow
import { boolean, string } from 'yup';

import {
  ENABLE,
  ENABLED,
  NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG,
  NATIVE_INFERENCE_POOL_DETAILS_FORM,
  NATIVE_INFERENCE_POOL_ENABLED_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_MODEL,
  NATIVE_INFERENCE_POOL_MODEL_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_MODEL_LABEL_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_FORM,
  NATIVE_INFERENCE_POOL_NAME,
  NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_PROVIDER,
  NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_REGION,
  NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME,
  NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_FORM,
  NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
} from '../constants';
import { CHECKBOX_INPUT_TYPE, SELECT_INPUT_TYPE, TEXT_INPUT_TYPE } from '../formik-utils/consts';
import { clusterMonthlyDataInputTransformationFunc } from '../components/cluster/cluster-input-table/utils';
import { getMonthlyInputsValidationFuncForType } from '../components/cluster/cluster-details-inputs/kafka-monthly-inputs-validation';
import {
  nativeInferencePoolTokenModelsInputTransformFunc,
  nativeInferencePoolTokenBasedModelsValidationFunc,
} from '../components/native-inference-pool-top-level/native-inference-pool-details-inputs-section/utils';

import { convertConfigArrayToMap, createFormNameToFieldsMap } from './utils';

export const NATIVE_INFERENCE_POOL_DETAILS_CONFIG = [
  {
    displayName: NATIVE_INFERENCE_POOL_NAME,
    backendFieldName: NATIVE_INFERENCE_POOL_NAME_BACKEND_NAME,
    icon: null,
    validation: string().label(NATIVE_INFERENCE_POOL_NAME).required(),
    inputType: TEXT_INPUT_TYPE,
    belongingForm: NATIVE_INFERENCE_POOL_DETAILS_FORM,
  },
  {
    displayName: ENABLE,
    backendFieldName: NATIVE_INFERENCE_POOL_ENABLED_BACKEND_NAME,
    icon: null,
    validation: boolean().label(ENABLED).required(),
    inputType: CHECKBOX_INPUT_TYPE,
    // No belongingForm - saved via its own enable/disable mutation, not the Details form.
  },
  {
    displayName: NATIVE_INFERENCE_POOL_PROVIDER,
    backendFieldName: NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME,
    icon: null,
    inputType: SELECT_INPUT_TYPE,
    belongingForm: NATIVE_INFERENCE_POOL_DETAILS_FORM,
    validation: string().required().label(NATIVE_INFERENCE_POOL_PROVIDER).nullable(),
  },
  {
    displayName: NATIVE_INFERENCE_POOL_REGION,
    backendFieldName: NATIVE_INFERENCE_POOL_REGION_BACKEND_NAME,
    icon: null,
    inputType: SELECT_INPUT_TYPE,
    belongingForm: NATIVE_INFERENCE_POOL_DETAILS_FORM,
    validation: string().required().label(NATIVE_INFERENCE_POOL_REGION).nullable(),
    parentFieldsInGroup: [NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME],
    displayNameCol: 'region_label',
  },
  {
    displayName: NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG,
    backendFieldName: NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG,
    belongingForm: NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_FORM,
    inputTransformationFunc: clusterMonthlyDataInputTransformationFunc,
    validation: getMonthlyInputsValidationFuncForType(
      NATIVE_INFERENCE_POOL_CCU_MONTHLY_INPUTS_JSON_CONFIG
    ),
  },
  {
    displayName: NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
    backendFieldName: NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_JSON_CONFIG,
    belongingForm: NATIVE_INFERENCE_POOL_TOKEN_BASED_MODELS_FORM,
    inputTransformationFunc: nativeInferencePoolTokenModelsInputTransformFunc,
    validation: nativeInferencePoolTokenBasedModelsValidationFunc,
  },
  {
    // Transient "model to add" selector - not part of any saved form, just drives the Add Model dropdown.
    displayName: NATIVE_INFERENCE_POOL_MODEL,
    backendFieldName: NATIVE_INFERENCE_POOL_MODEL_BACKEND_NAME,
    displayNameCol: NATIVE_INFERENCE_POOL_MODEL_LABEL_BACKEND_NAME,
    parentFieldsInGroup: [NATIVE_INFERENCE_POOL_PROVIDER_BACKEND_NAME],
  },
];

export const NATIVE_INFERENCE_POOL_DETAILS_CONFIG_MAP = convertConfigArrayToMap(
  NATIVE_INFERENCE_POOL_DETAILS_CONFIG
);
export const NATIVE_INFERENCE_POOL_DETAILS_FORM_NAMES_TO_FIELDS_MAP = createFormNameToFieldsMap(
  NATIVE_INFERENCE_POOL_DETAILS_CONFIG
);
